import { apiFetch } from "@/lib/api";

export interface SuntronicUnbilledByDayRow {
  creation_day: string | null;
  total_service_cost_usd: string | null;
  line_items: string | null;
  units: string | null;
  average_remaining_percentage: string | null;
}

export interface SuntronicUnbilledFinishedGoodRow {
  creation_day: string | null;
  service_cost: string | null;
  quantity: string | null;
  mv_build_order_number: string | null;
  wofg_number: string | null;
  batch_id: string | null;
  sku: string | null;
  unit_cost: string | null;
  mfr_ship_by_date: string | null;
}

export interface SuntronicUnbilledMatchedShipmentRow {
  shipment_id: string | null;
  batch_id: string | null;
  sku: string | null;
  date_shipped: string | null;
  shipment_quantity: string | null;
  total_matched_quantity: string | null;
  mfr_invoice_ids: string | null;
  mfr_invoice_numbers: string | null;
  tla_quantity: string | null;
  tla_kit_quantity: string | null;
  tla_purchase_order_number: string | null;
  build_order_id: string | null;
  batch_item_id: string | null;
  purchase_order_item_id: string | null;
  location_name: string | null;
}

export interface SuntronicUnbilledLaborReport {
  totalUnbilledUsd: string | null;
  byCreationDay: SuntronicUnbilledByDayRow[];
  unmatchedFinishedGoods: SuntronicUnbilledFinishedGoodRow[];
  matchedShipments: SuntronicUnbilledMatchedShipmentRow[];
}

export async function fetchSuntronicUnbilledLabor(): Promise<SuntronicUnbilledLaborReport> {
  return apiFetch<SuntronicUnbilledLaborReport>("/api/accounting/suntronic-unbilled-labor");
}
